'use strict';

var $ = require('jquery');

// Constructor
var KnowledgeBaseModal = function() {
    fixTabs();
    $('.kbs-article__close').on('click touchstart', function (e) {
        $('html').css('overflow', 'scroll');
        $('body').removeClass('show-kbs');
    });
};

function fixTabs() {
    var tabContainer = $('div.kbs-article__tabs');
    var tabs = tabContainer.find('.tabs');
    var tabContents = tabContainer.find('.tab-content');

    tabContents.hide();
    tabContents.first().show();

    tabs.find('a').on('click touchstart', function (e) {
        var tabId = $(this).attr('id').replace('tab_', '');
        tabs.find('li').removeClass('is-active');
        $(this).parent().addClass('is-active');
        tabContents.hide();
        $('#content_' + tabId).show();
    });

    tabContents.find('.media-item').on('click touchstart', function (e) {
        $(this).toggleClass('enlarge');
    });
}

module.exports = KnowledgeBaseModal;
